import { RDIrrigation } from '@cibo/core'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DetailPanel } from '../DetailPanel'
import { IrrigationPanelTable } from './IrrigationPanelTable'

export const IrrigationPanel = () => {
  const { t } = useTranslation('@cibo/landmanager/IrrigationPanel')

  return (
    <DetailPanel<RDIrrigation>
      title={t('irrigation')}
      traitId="irrigation"
      DetailTable={IrrigationPanelTable}
      DetailIndividual={({ currentYearData }: { currentYearData?: RDIrrigation }) => (
        <Typography variant="subtitle1">
          {t(
            currentYearData?.result === undefined
              ? '--'
              : !!currentYearData?.result
              ? 'irrigated'
              : 'notIrrigated'
          )}
        </Typography>
      )}
    />
  )
}
